module.exports = __webpack_public_path__ + "static/media/r135.3ab9d28a.jpg";